import { render, staticRenderFns } from "./PodcastOverview.vue?vue&type=template&id=ff6c573a&"
import script from "./PodcastOverview.vue?vue&type=script&lang=js&"
export * from "./PodcastOverview.vue?vue&type=script&lang=js&"
import style0 from "./PodcastOverview.vue?vue&type=style&index=0&id=ff6c573a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default})
